import {multilingualStringPreview} from '@/lib/multilingualArrayString'
import dotcomDestination from '@/schemaTypes/fragments/dotcom.destination'
import {defineField, defineType} from 'sanity'

export default defineType({
  name: 'destinationCta',
  type: 'object',
  title: 'Destination CTA',
  fields: [
    {
      name: 'label',
      type: 'string',
    },
    {
      name: 'buttonType',
      type: 'buttonType',
    },
    defineField({...dotcomDestination}),
  ],
  preview: {
    select: {
      title: 'label',
      subtitle: 'destination.name',
    },
    prepare({title, subtitle}) {
      return {
        title: title,
        subtitle: multilingualStringPreview(subtitle),
      }
    },
  },
})
